import prefill from './prefill';
import sets from './sets';

export default prefill({
  /* eslint-disable quote-props */
  'ddc994': {},
  'f5a76e': {},
  'ea8349': {},
  'c06534': {},
  '98461a': {},
  '915533': {},
  'c3e1dc': {},
  '6bd049': {},

  'eb052b': { price: 2, set: sets.rainbowSkins },
  'f69922': { price: 2, set: sets.rainbowSkins },
  'f5d70f': { price: 2, set: sets.rainbowSkins },
  '0ff591': { price: 2, set: sets.rainbowSkins },
  '2b43f6': { price: 2, set: sets.rainbowSkins },
  'd7a9f7': { price: 2, set: sets.rainbowSkins },
  '800ed0': { price: 2, set: sets.rainbowSkins },
  'rainbow': { price: 2, set: sets.rainbowSkins },

  'bear': { price: 2, set: sets.animalSkins },
  'cactus': { price: 2, set: sets.animalSkins },
  'fox': { price: 2, set: sets.animalSkins },
  'lion': { price: 2, set: sets.animalSkins },
  'panda': { price: 2, set: sets.animalSkins },
  'pig': { price: 2, set: sets.animalSkins },
  'tiger': { price: 2, set: sets.animalSkins },
  'wolf': { price: 2, set: sets.animalSkins },

  'pastelPink': { price: 2, set: sets.pastelSkins },
  'pastelOrange': { price: 2, set: sets.pastelSkins },
  'pastelYellow': { price: 2, set: sets.pastelSkins },
  'pastelGreen': { price: 2, set: sets.pastelSkins },
  'pastelBlue': { price: 2, set: sets.pastelSkins },
  'pastelPurple': { price: 2, set: sets.pastelSkins },
  'pastelRainbowChevron': { price: 2, set: sets.pastelSkins },
  'pastelRainbowDiagonal': { price: 2, set: sets.pastelSkins },

  'monster': { price: 2, set: sets.spookySkins },
  'pumpkin': { price: 2, set: sets.spookySkins },
  'skeleton': { price: 2, set: sets.spookySkins },
  'zombie': { price: 2, set: sets.spookySkins },
  'ghost': { price: 2, set: sets.spookySkins },
  'shadow': { price: 2, set: sets.spookySkins },

  'candycorn': { price: 2, set: sets.supernaturalSkins },
  'ogre': { price: 2, set: sets.supernaturalSkins },
  'pumpkin2': { price: 2, set: sets.supernaturalSkins },
  'reptile': { price: 2, set: sets.supernaturalSkins },
  'shadow2': { price: 2, set: sets.supernaturalSkins },
  'skeleton2': { price: 2, set: sets.supernaturalSkins },
  'transparent': { price: 2, set: sets.supernaturalSkins },
  'zombie2': { price: 2, set: sets.supernaturalSkins },

  'clownfish': { price: 2, set: sets.splashySkins },
  'deepocean': { price: 2, set: sets.splashySkins },
  'merblue': { price: 2, set: sets.splashySkins },
  'mergold': { price: 2, set: sets.splashySkins },
  'mergreen': { price: 2, set: sets.splashySkins },
  'merruby': { price: 2, set: sets.splashySkins },
  'shark': { price: 2, set: sets.splashySkins },
  'tropicalwater': { price: 2, set: sets.splashySkins },

  'aurora': { price: 2, set: sets.winterySkins },
  'dapper': { price: 2, set: sets.winterySkins },
  'festive': { price: 2, set: sets.winterySkins },
  'holly': { price: 2, set: sets.winterySkins },
  'polar': { price: 2, set: sets.winterySkins },
  'sugar': { price: 2, set: sets.winterySkins },
  'snowy': { price: 2, set: sets.winterySkins },
  'winterstar': { price: 2, set: sets.winterySkins },

  /* eslint-enable quote-props */
});
